import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { CascadeImpact, Cost } from "../../models/cost.model";
import { environment } from "../../../../../environments/environment";

@Injectable({ providedIn: "root" })
export class CostApiService implements EntityApiService<Cost> {
  httpClient = inject(HttpClient);

  loadOne(id: string): Observable<Cost> {
    throw new Error("Method not implemented.");
  }

  loadAll(): Observable<Cost[]> {
    throw new Error("Method not implemented.");
  }

  loadForLot(lotId: string): Observable<Cost[]> {
    return this.httpClient.get<Cost[]>(`${environment.api()}/cost/lotId/${lotId}`);
  }

  create(cost: Cost): Observable<Cost> {
    return this.httpClient.post<Cost>(`${environment.api()}/cost`, cost);
  }

  update(cost: Cost): Observable<Cost> {
    return this.httpClient.post<Cost>(`${environment.api()}/cost`, cost);
  }

  remove(id: string): Observable<string> {
    return this.httpClient.delete<string>(`${environment.api()}/cost/id/${id}`);
  }

  /** Liste les lots + OFs aval impactés par une modification du coût de ce lot.
   *  Endpoint hébergé par CalculCascadeController pour éviter un cycle de
   *  modules (CostModule ↔ TracabiliteModule). */
  loadCascadeImpact(lotId: string): Observable<CascadeImpact> {
    return this.httpClient.get<CascadeImpact>(
      `${environment.api()}/calcul_cascade/lot/${lotId}/impact`,
    );
  }

  /** Déclenche manuellement le recalcul cascade sur les éléments aval. */
  triggerCascade(lotId: string): Observable<{ queued: number }> {
    return this.httpClient.post<{ queued: number }>(
      `${environment.api()}/calcul_cascade/lot/${lotId}/trigger`,
      {},
    );
  }
}
